var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.styleType,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('fireClick')}}},[_vm._v(" "+_vm._s(_vm.btnText)+" "),(_vm.isLoading)?_c('span',{staticClass:"btn_loader"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }